import React from 'react'

function Footer() {
  return (
    <div>
      <span>Chris</span>
    </div>
  )
}

export default Footer